<template>
  <div id="app">
    <div class="row">

      <div class="col-12">
        <h2 class="generalTitle d-flex align-items-center justify-content-between">Promociones
          <div class="d-flex align-items-center">
            <router-link v-if="$store.state.roles.Backoffice_Superadmin" class="nav-link px-1 mr-3" :to="{ name: 'newPromotionStep1' }">
              <v-icon name="hi-plus" scale="1.2" class="mr-1" />Crear promoción
            </router-link>
            <a href="#" class="nav-link px-1 mr-3" @click.prevent="openMassiveUploadModal">
              <v-icon name="bi-upload" scale="1.2" class="mr-1" />Carga Masiva Promociones
            </a>
            <a href="#" class="nav-link px-1" @click.prevent="openMassiveCorrectionModal">
              <v-icon name="md-autorenew" scale="1.2" class="mr-1" />Corrección Masiva Promociones
            </a>
          </div>
        </h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <list-filters @filter="handleFilter" :isLoading="isLoading" :filterURL="filterURL" />

      </div>
      <div v-if="isLoading" class="progress-renew">
        <div class="progress-bar-renew"></div>
      </div>
      <div class="col-12" v-if="!isLoading && promotions && promotions.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1">
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }} promociones</p>
            </div>
            <list :promotions="promotions" @sendRefreshRegisterList="sendRefreshRegisterList()" @selectOrder="selectOrder($event)"/>
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                            @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Promociones por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12" v-else-if="!isLoading && (!promotions || promotions.length === 0)">
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>
    <!-- Modal de carga masiva -->
    <Modal
        id="massiveUploadModal"
        :modalTitle="'Carga Masiva de Promociones'"
        class="modal-lg"
        v-show="showMassiveUploadModal"
        ref="massiveUploadModal"
        @onClose="closeMassiveUploadModal"
    >
      <!-- Mostrar mensaje de éxito -->
      <div v-if="showSuccessMessage" class="alert alert-success text-center">
        <v-icon name="hi-check-circle" scale="1.5" class="text-success mb-2" />
        <h5>¡Proceso completado exitosamente!</h5>
        <p class="mb-0">{{ successMessage }}</p>
        <small class="text-muted">Este modal se cerrará automáticamente...</small>
      </div>

      <form v-else @submit.prevent="handleMassiveUpload">
        <div class="form-group">
          <label for="csvFile">Selecciona un archivo CSV</label>
          <input
              type="file"
              class="form-control"
              id="csvFile"
              accept=".csv"
              @change="onFileChange"
              :disabled="isUploading || uploadStatus === 'processing'"
              required
          />
        </div>

        <div v-if="uploadStatus === 'processing'" class="form-group">
          <label>Procesando archivo...</label>
          <div class="progress">
            <div class="progress-bar" :style="{ width: uploadProgress + '%' }" role="progressbar">
              {{ uploadProgress }}%
            </div>
          </div>
          <small class="text-muted">Este proceso puede tardar varios minutos para archivos grandes.</small>
        </div>

        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>

        <button type="submit" class="btn btn-primary" :disabled="isUploading || uploadStatus === 'processing'">
          <span v-if="isUploading">Subiendo archivo...</span>
          <span v-else-if="uploadStatus === 'processing'">Procesando...</span>
          <span v-else>Cargar promociones</span>
        </button>

        <button type="button" class="btn btn-secondary ml-2" @click="closeMassiveUploadModal" :disabled="uploadStatus === 'processing'">
          Cancelar
        </button>
      </form>
    </Modal>

    <!-- Modal de corrección masiva -->
    <Modal
        id="massiveCorrectionModal"
        :modalTitle="'Corrección Masiva de Promociones'"
        class="modal-lg"
        v-show="showMassiveCorrectionModal"
        ref="massiveCorrectionModal"
        @onClose="closeMassiveCorrectionModal"
    >
      <!-- Mostrar mensaje de éxito -->
      <div v-if="showCorrectionSuccessMessage" class="alert alert-success text-center">
        <v-icon name="hi-check-circle" scale="1.5" class="text-success mb-2" />
        <h5>¡Proceso completado exitosamente!</h5>
        <p class="mb-0">{{ correctionSuccessMessage }}</p>
        <small class="text-muted">Este modal se cerrará automáticamente...</small>
      </div>

      <form v-else @submit.prevent="handleMassiveCorrection">
        <div class="form-group">
          <label for="correctionCsvFile">Selecciona un archivo CSV</label>
          <input
              type="file"
              class="form-control"
              id="correctionCsvFile"
              accept=".csv"
              @change="onCorrectionFileChange"
              :disabled="isCorrectionUploading || correctionUploadStatus === 'processing'"
              required
          />
        </div>

        <div v-if="correctionUploadStatus === 'processing'" class="form-group">
          <label>Procesando archivo...</label>
          <div class="progress">
            <div class="progress-bar" :style="{ width: correctionUploadProgress + '%' }" role="progressbar">
              {{ correctionUploadProgress }}%
            </div>
          </div>
          <small class="text-muted">Este proceso puede tardar varios minutos para archivos grandes.</small>
        </div>

        <div v-if="correctionErrorMessage" class="alert alert-danger">
          {{ correctionErrorMessage }}
        </div>

        <button type="submit" class="btn btn-primary" :disabled="isCorrectionUploading || correctionUploadStatus === 'processing'">
          <span v-if="isCorrectionUploading">Subiendo archivo...</span>
          <span v-else-if="correctionUploadStatus === 'processing'">Procesando...</span>
          <span v-else>Corregir promociones</span>
        </button>

        <button type="button" class="btn btn-secondary ml-2" @click="closeMassiveCorrectionModal" :disabled="correctionUploadStatus === 'processing'">
          Cancelar
        </button>
      </form>
    </Modal>

  </div>
</template>

<script>
import ListFilters from '@/components/Widgets/Shared/PromotionsListFilters.vue';
import List from './templates/List.vue';
import axios from 'axios';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
//import { useRoute } from 'vue-router';
import Modal from '@/components/Widgets/Shared/Modal.vue';

export default {
  name: 'App',
  components: {
    ListFilters,
    List,
    Pagination,
    Modal,

  },

  data() {
    return {
      promotions: '',
      isLoading: false,
      name: '',
      promotionId: '',
      status: '',
      filters: '',
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
      filterURL: '',
      showMassiveUploadModal: false,
      isUploading: false,
      csvFile: null,
      showSuccessModal: false,
      successMessage: '',
      errorMessage: '',
      uploadTaskId: null,
      uploadProgress: 0,
      isPolling: false,
      uploadStatus: 'idle',
      pollingRetryCount: 0,
      showSuccessMessage: false,
      // Corrección masiva
      showMassiveCorrectionModal: false,
      isCorrectionUploading: false,
      correctionCsvFile: null,
      correctionSuccessMessage: '',
      correctionErrorMessage: '',
      correctionUploadProgress: 0,
      correctionUploadStatus: 'idle',
      showCorrectionSuccessMessage: false,
    };
  },
  created() {
    this.isLoading = true;
    if (this.$route.query.filterURL) {
      this.filterURL = this.$route.query.filterURL;
    } else {
      this.loadPromotions();
    }
  },

  methods: {
    handleFilter(value) {

      this.isLoading = true;
      this.name = value.name || '';
      this.promotionId = value.promotionId || '';
      this.status = value.status || '';
      this.currentPage = 0;
      this.loadPromotions();
    },
    filtername() {
      if (this.name !== '' && this.name !== undefined) {
        this.filters = `${this.filters}name=${this.name}&`;
      }
    },
    filterPromotionId() {
      if (this.promotionId !== '' && this.promotionId !== undefined) {
        this.filters = `${this.filters}promotionId=${this.promotionId}&`;
      }
    },
    filterStatus() {
      if (this.status !== '' && this.status !== undefined) {
        this.filters = `${this.filters}status=${this.status}&`;
      }
    },
    filterPagination() {
      this.filters = `${this.filters}pagination.pageSize=${this.itemsPerPage}&`;
      this.filters = `${this.filters}pagination.page=${parseInt(this.currentPage + 1)}&`;
    },
    selectPage(value) {
      this.currentPage = value;
      this.loadPromotions();
    },
    selectOrder(value) {
      console.log(value);
      //Rellenar con el order cuando sepamos el formato
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.loadPromotions();
    },
    async loadPromotions() {
      this.filters = '';
      if (this.name) this.filters += `name=${encodeURIComponent(this.name)}&`;
      if (this.promotionId) this.filters += `promotionId=${encodeURIComponent(this.promotionId)}&`;
      if (this.status) this.filters += `status=${encodeURIComponent(this.status)}&`;
      this.filters += `pagination.pageSize=${this.itemsPerPage}&pagination.page=${this.currentPage + 1}&`;

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      try {
        const response = await axios.get(`/promotions/promotion/search${this.filters}`);
        this.promotions = response.data.promotions;
        this.totalItems = response.data.pagination.totalElements;
        this.numberPages = Math.ceil(this.totalItems / this.itemsPerPage);
        this.from = this.currentPage * this.itemsPerPage + 1;
        this.to = Math.min((this.currentPage + 1) * this.itemsPerPage, this.totalItems);
      } catch (error) {
        console.error('Error al cargar promociones:', error);
        this.promotions = [];
      } finally {
        this.isLoading = false; // Desactivar estado de carga al finalizar
      }
    },
    sendRefreshRegisterList() {
      this.loadPromotions()
    },
    openMassiveUploadModal() {
      this.showMassiveUploadModal = true;
      this.$nextTick(() => {
        if (this.$refs.massiveUploadModal && this.$refs.massiveUploadModal.show) {
          this.$refs.massiveUploadModal.show();
        }
      });
    },
    closeMassiveUploadModal() {
      // Solo permitir cerrar si no está procesando
      if (this.uploadStatus === 'processing') {
        return;
      }

      if (this.$refs.massiveUploadModal?.hide) {
        this.$refs.massiveUploadModal.hide();
      }

      this.showMassiveUploadModal = false;
      this.csvFile = null;
      this.resetUploadState();
      this.errorMessage = '';
      this.showSuccessMessage = false; // Resetear mensaje de éxito
      this.successMessage = '';
    },
    async onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      try {
        await this.validateCsvFile(file);
        this.csvFile = file;
      } catch (error) {
        alert(error);
        this.csvFile = null;
      }
    },
    async validateCsvFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          try {
            const text = e.target.result;
            const lines = text.split(/\r?\n/).filter(line => line.trim() !== '');

            if (lines.length < 2) {
              reject('El archivo debe contener al menos una fila de datos además de las cabeceras.');
              return;
            }

            const firstLine = lines[0];
            const delimiter = firstLine.includes(';') ? ';' : ',';
            const headers = firstLine.split(delimiter).map(h => h.trim().toLowerCase());
            console.log('Headers detectados:', headers);

            if (!headers.includes('contractid') || !headers.includes('promotionid')) {
              reject('El archivo debe contener exactamente las columnas: contractId, promotionId');
              return;
            }

            const dataLines = lines.slice(1).filter(line => line.trim() !== '');
            if (dataLines.length === 0) {
              reject('El archivo no contiene filas de datos.');
              return;
            }

            console.log(`Archivo válido: ${dataLines.length} filas de datos detectadas`);
            resolve(true);

          } catch (error) {
            reject('Error al procesar el archivo CSV.');
          }
        };
        reader.onerror = () => reject('No se pudo leer el archivo.');
        reader.readAsText(file);
      });
    },
    async handleMassiveUpload() {
      if (!this.csvFile) return;

      this.isUploading = true;
      this.uploadStatus = 'processing';
      this.uploadProgress = 0;
      this.errorMessage = ''; // Limpiar errores previos

      const formData = new FormData();
      formData.append('csv', this.csvFile);

      try {
        await axios.patch('/promotions/associate-promotion-contract', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            this.uploadProgress = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          },
        });

        this.uploadStatus = 'done';
        this.isUploading = false;

        // Mostrar mensaje de éxito
        this.showSuccessMessage = true;
        this.successMessage = 'Las promociones han sido cargadas correctamente.';

        // Cerrar modal después de 3 segundos
        setTimeout(() => {
          this.closeMassiveUploadModal();
          this.loadPromotions(); // Refrescar la lista
        }, 3000);

      } catch (error) {
        this.errorMessage = 'Error al subir archivo CSV';
        this.uploadStatus = 'error';
        this.isUploading = false;
      }
    },



    startPolling() {
      if (this.isPolling) return;

      this.isPolling = true;
      this.pollingStartTime = Date.now(); // Registrar cuando inició
      this.pollUploadStatus();
    },

    async pollUploadStatus() {
      if (!this.uploadTaskId || !this.isPolling) return;

      // Verificar timeout
      const elapsedTime = Date.now() - this.pollingStartTime;
      if (elapsedTime > this.maxPollingDuration) {
        this.handleUploadError({
          response: {
            data: {
              message: 'El procesamiento está tardando más de lo esperado. Por favor, contacta soporte.'
            }
          }
        });
        this.stopPolling();
        return;
      }

      try {
        const response = await axios.get(`/promotions/upload-status/${this.uploadTaskId}`);

        // Validar que la respuesta tenga la estructura esperada
        if (!response.data || typeof response.data.status !== 'string') {
          throw new Error('Respuesta inválida del servidor');
        }

        const { status, progress, message, result } = response.data;

        this.uploadProgress = Math.min(Math.max(progress || 0, 0), 100); // Asegurar rango 0-100
        this.uploadStatus = status;

        switch (status) {
          case 'processing':
          case 'pending':
            setTimeout(() => this.pollUploadStatus(), 2000);
            break;

          case 'completed':
            this.handleUploadSuccess(result);
            this.stopPolling();
            break;

          case 'error':
          case 'failed':
            this.handleUploadError({ response: { data: { message } } });
            this.stopPolling();
            break;

          default:
            console.warn(`Estado desconocido: ${status}`);
            setTimeout(() => this.pollUploadStatus(), 2000);
        }

      } catch (error) {
        console.error('Error al consultar estado:', error);

        // Implementar retry con backoff exponencial
        const retryDelay = this.pollingRetryCount ? Math.min(5000 * Math.pow(2, this.pollingRetryCount), 30000) : 5000;
        this.pollingRetryCount = (this.pollingRetryCount || 0) + 1;

        // Limitar reintentos
        if (this.pollingRetryCount > 5) {
          this.handleUploadError({
            response: {
              data: {
                message: 'No pudimos obtener el estado del procesamiento. Por favor, verifica manualmente o contacta soporte.'
              }
            }
          });
          this.stopPolling();
        } else {
          setTimeout(() => this.pollUploadStatus(), retryDelay);
        }
      }
    },

    stopPolling() {
      this.isPolling = false;
      this.uploadTaskId = null;
    },
    handleUploadSuccess(result) {
      this.successMessage = `Carga completada exitosamente. ${result?.processedCount || 0} promociones procesadas.`;
      this.showSuccessModal = true;
      this.closeMassiveUploadModal();
      this.loadPromotions(); // Refrescar lista
      this.resetUploadState();
    },

    handleUploadError(error) {
      console.error('Error al cargar promociones masivas:', error);

      let userMessage = 'Ocurrió un error al procesar el archivo.';
      let technicalDetails = '';

      if (error.response?.data) {
        technicalDetails = typeof error.response.data === 'string'
            ? error.response.data
            : JSON.stringify(error.response.data);
        console.log('Detalles del backend:', technicalDetails);
      }

      if (error.response?.data?.message) {
        userMessage = error.response.data.message;
      } else if (error.response) {
        const status = error.response.status;
        switch (status) {
          case 404:
            userMessage = 'Servicio no disponible. Intenta más tarde.';
            break;
          case 400:
            userMessage = 'Archivo inválido. Verifica las columnas contractId y promotionId.';
            break;
          case 413:
            userMessage = 'El archivo es demasiado grande. Intenta con un archivo menor.';
            break;
          case 500:
            userMessage = 'Error del servidor. Intenta nuevamente en unos minutos.';
            break;
          default:
            userMessage = 'No pudimos procesar el archivo. Intenta nuevamente.';
        }
      }

      this.errorMessage = userMessage;
      this.resetUploadState();
    },

    resetUploadState() {
      this.isUploading = false;
      this.uploadStatus = 'idle';
      this.uploadProgress = 0;
      this.pollingRetryCount = 0;
      this.stopPolling();
    },
    // Métodos para corrección masiva
    openMassiveCorrectionModal() {
      this.showMassiveCorrectionModal = true;
      this.$nextTick(() => {
        if (this.$refs.massiveCorrectionModal && this.$refs.massiveCorrectionModal.show) {
          this.$refs.massiveCorrectionModal.show();
        }
      });
    },
    closeMassiveCorrectionModal() {
      if (this.correctionUploadStatus === 'processing') {
        return;
      }

      if (this.$refs.massiveCorrectionModal?.hide) {
        this.$refs.massiveCorrectionModal.hide();
      }

      this.showMassiveCorrectionModal = false;
      this.correctionCsvFile = null;
      this.resetCorrectionUploadState();
      this.correctionErrorMessage = '';
      this.showCorrectionSuccessMessage = false;
      this.correctionSuccessMessage = '';
    },
    async onCorrectionFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      try {
        await this.validateCsvFile(file);
        this.correctionCsvFile = file;
      } catch (error) {
        alert(error);
        this.correctionCsvFile = null;
      }
    },
    async handleMassiveCorrection() {
      if (!this.correctionCsvFile) return;

      this.isCorrectionUploading = true;
      this.correctionUploadStatus = 'processing';
      this.correctionUploadProgress = 0;
      this.correctionErrorMessage = '';

      const formData = new FormData();
      formData.append('csv', this.correctionCsvFile);
      formData.append('fix_promotion', 'true');

      try {
        await axios.patch('/promotions/fixed-promotion-duplicated', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          onUploadProgress: (progressEvent) => {
            this.correctionUploadProgress = parseInt(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          },
        });

        this.correctionUploadStatus = 'done';
        this.isCorrectionUploading = false;

        this.showCorrectionSuccessMessage = true;
        this.correctionSuccessMessage = 'Las promociones han sido corregidas correctamente.';

        setTimeout(() => {
          this.closeMassiveCorrectionModal();
          this.loadPromotions();
        }, 3000);

      } catch (error) {
        this.correctionErrorMessage = error.response?.data?.message || 'Error al procesar el archivo CSV de corrección';
        this.correctionUploadStatus = 'error';
        this.isCorrectionUploading = false;
      }
    },
    resetCorrectionUploadState() {
      this.isCorrectionUploading = false;
      this.correctionUploadStatus = 'idle';
      this.correctionUploadProgress = 0;
    },
  },
};
</script>

<style lang="scss">
.progress-renew {
  width: 100%;
  height: 4px !important;
  background-color: #fbfbfb;
  position: relative;
  margin-bottom: 2px;
  overflow: hidden; /* Asegura que la barra no se salga del contenedor */
}

.progress-bar-renew {
  height: 100%;
  background-color: #97055D;
  position: absolute;
  left: 0;
  animation: grow 2s linear infinite; /* Ajustamos la animación */
}

@keyframes grow {
  0% {
    width: 0;
  }
  100% {
    width: 100%;
  }
}

.progress-bar {
  background-color: #007bff;
  height: 1.5rem;
  color: white;
  text-align: center;
  line-height: 1.5rem;
}

</style>
